/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharekindinterest2Inputs */

const en_sharekindinterest2 = /** @type {(inputs: Sharekindinterest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answer or plan`)
};

const de_sharekindinterest2 = /** @type {(inputs: Sharekindinterest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusage oder Plan`)
};

/**
* | output |
* | --- |
* | "Answer or plan" |
*
* @param {Sharekindinterest2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharekindinterest2 = /** @type {((inputs?: Sharekindinterest2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharekindinterest2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharekindinterest2(inputs)
	return de_sharekindinterest2(inputs)
});
export { sharekindinterest2 as "shareKindInterest" }